import React from "react";
import { PARTNERS } from "../lib/siteData";

export default function Partners() {
  // Duplicate list for seamless marquee
  const marquee = [...PARTNERS, ...PARTNERS];

  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="py-20 sm:py-28 relative overflow-hidden bg-ink text-ivory"
    >
      <div className="container-prose">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <p className="overline text-saffron">02 — Trusted Collaborations</p>
            <h2 className="h2-display mt-4 text-4xl sm:text-6xl text-ivory">
              Where my work <span className="italic text-saffron">travels</span>.
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="body-prose text-base sm:text-lg text-ivory/75 max-w-xl">
              From government boards and international academies to global tech ecosystems —
              a partial list of the institutions Karamjeet has trained, advised or collaborated with
              across two decades.
            </p>
          </div>
        </div>
      </div>

      {/* Marquee row 1 */}
      <div className="relative w-full overflow-hidden py-6 border-y border-ivory/15">
        <div className="flex gap-12 animate-marquee whitespace-nowrap">
          {marquee.map((p, i) => (
            <div
              key={`m1-${i}`}
              className="flex items-center gap-4 shrink-0"
              data-testid={`partner-marquee-${i}`}
            >
              <span
                className="text-3xl sm:text-5xl"
                style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
              >
                {p.name}
              </span>
              <span className="text-saffron text-2xl">✺</span>
            </div>
          ))}
        </div>
      </div>

      {/* Grid below for accessibility & SEO */}
      <div className="container-prose mt-14">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-ivory/10">
          {PARTNERS.map((p, i) => (
            <div
              key={p.name}
              data-testid={`partner-card-${i}`}
              className="bg-ink p-5 sm:p-6 hover:bg-saffron hover:text-ink transition-colors group"
            >
              <p className="text-[10px] uppercase tracking-[0.22em] text-saffron group-hover:text-ink/70">
                {p.tag}
              </p>
              <p
                className="mt-2 text-lg sm:text-xl leading-tight"
                style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
              >
                {p.name}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover { animation-play-state: paused; }
      `}</style>
    </section>
  );
}
